module.exports = __webpack_public_path__ + "img/2.b3e2d1c1.png";